import { render, staticRenderFns } from "./AsideAdSlot.vue?vue&type=template&id=49edacf1&scoped=true"
import script from "./AsideAdSlot.vue?vue&type=script&lang=js"
export * from "./AsideAdSlot.vue?vue&type=script&lang=js"
import style0 from "./AsideAdSlot.vue?vue&type=style&index=0&id=49edacf1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49edacf1",
  null
  
)

export default component.exports